import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// POST /ajax/order_line_estimate/{district_id}
export const orderEstimate = async (
  districtId: number,
  payload: { payments: Record<string, TFormattedPayment[]>; fundingSourceId: number | null }
): Promise<TOrderItem[][]> => {
  return new Promise<TOrderItem[][]>((resolve, reject) => {
    // Explicitly type the Promise
    const req = new Request()
    req
      .post(`/ajax/order_line_estimate/${districtId}`, Util.Obj.keysToSnake(payload))
      .then(response => {
        resolve(Util.Obj.keysToCamel(response.data.estimate) as TOrderItem[][])
      })
      .catch(err => {
        reject(new Error('Failed to get order estimate: ' + err)) // Reject with an Error object
      })
  })
}
